/**
 * Configuration Loader (Legacy - now uses CentralizedConfig)
 * @deprecated Use centralizedConfig from './centralizedConfig.js' instead
 * This file is maintained for backward compatibility
 */

import { centralizedConfig } from './centralizedConfig';

class ConfigLoader {
  constructor() {
    this.config = null;
    this.isLocalhost = centralizedConfig.isRunningLocally();
    this.initialized = false;
  }

  /**
   * Wait for configuration to be initialized
   */
  async waitForInitialization() {
    if (this.initialized) {
      return this.config;
    }
    
    await centralizedConfig.waitForInitialization();
    this.config = centralizedConfig.getAll();
    this.initialized = true;
    return this.config;
  }

  /**
   * Get configuration value (synchronous - may return null if not initialized)
   */
  get(key, defaultValue = null) {
    if (!this.initialized || !this.config) {
      console.warn('⚠️ Configuration not yet initialized, returning default value for:', key);
      return defaultValue;
    }
    return this.config[key] || defaultValue;
  }

  /**
   * Get all configuration (synchronous - may return empty object if not initialized)
   */
  getAll() {
    if (!this.initialized || !this.config) {
      console.warn('⚠️ Configuration not yet initialized, returning empty object');
      return {};
    }
    return { ...this.config };
  }

  /**
   * Get configuration value (async - waits for initialization)
   */
  async getAsync(key, defaultValue = null) {
    await this.waitForInitialization();
    return this.config[key] || defaultValue;
  }

  /**
   * Get all configuration (async - waits for initialization)
   */
  async getAllAsync() {
    await this.waitForInitialization();
    return { ...this.config };
  }

  /**
   * Check if running on localhost
   */
  isRunningLocally() {
    return this.isLocalhost;
  }
}

// Create singleton instance
export const configLoader = new ConfigLoader();

// Export convenience function for getting config values
export const getConfig = (key, defaultValue = null) => configLoader.get(key, defaultValue);

// Export function to get all config
export const getAllConfig = () => configLoader.getAll();

// Export function to check if running locally
export const isLocalenviroment = () => configLoader.isRunningLocally();